import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-303">
      <div className="flex items-center gap-4 mb-6" data-id="element-304">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-305">
          {initials}
        </div>
        <div data-id="element-306">
          <div className="font-bold text-white" data-id="element-307">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-308">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-309">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-310" />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-311">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-312">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'VG',
    name: 'Valeria G.',
    location: 'Buenos Aires',
    quote: 'Llevaba 4 años con panza inflada. A los 7 días del protocolo empecé a notar la diferencia. Al día 14 ya no era la misma.'
  }, {
    initials: 'CM',
    name: 'Claudia M.',
    location: 'Córdoba',
    quote: 'Por fin alguien que explica en qué feria argentina comprar. Todo lo conseguí a la vuelta de mi casa.'
  }, {
    initials: 'LR',
    name: 'Laura R.',
    location: 'Rosario',
    quote: 'El Semáforo FODMAP argentino fue lo que me faltaba. Dejé de improvisar y la panza finalmente respondió.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-313">
      <div className="container mx-auto px-4" data-id="element-314">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-315">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-316" />)}
        </div>
      </div>
    </section>;
}